export default __webpack_public_path__ + "fonts/nuckle_semi_bold-webfont.woff";